/*
 ** vue router: Particular
 */
import type { RouteRecordRaw } from 'vue-router';

const vrtParticular: RouteRecordRaw = {
  path: '/elcpteltd/particular',
  name: 'vrtParticular',
  component: () => import('src/layouts/vcleSystem.vue'),
  children: [
    {
      path: 'create',
      name: 'vrtParticularCreate',
      component: () => import('./vpgParticularCreate.vue'),
    },
    {
      path: 'list',
      name: 'vrtParticularList',
      component: () => import('./vpgParticularList.vue'),
    },
    {
      path: 'update',
      name: 'vrtParticularOperate',
      component: () => import('./vpgParticularOperate.vue'),
    },
    {
      path: 'captcha',
      name: 'vrtParticularCaptcha',
      component: () => import('./vpgParticularCaptcha.vue'),
    },
  ],
};

export default vrtParticular;
